'use strict';

angular.module('itPurchasingControllers')

.controller('ItPurchasingMultiSelectActionsController', ['$scope', '$q', 'growl', 'ITPurchasingService', '$translate', function ($scope, $q, growl, ITPurchasingService, $translate) {

    $scope.multiSelectContainer = {};

    $scope.authorizeSelected = function () {
        $scope.view.isAuthorizing = true;

        $q
            .all(_.map($scope.getSelectedSystemsAndEmployees(), function (systemAndEmployee) {
                _.assign(systemAndEmployee, $scope.multiSelectContainer);

                return ITPurchasingService.authorizeSignificantCost(systemAndEmployee)
                    .then(function (updatedSystemAndEmployee) {
                        var updatedSystemAndEmployee = updatedSystemAndEmployee.SystemsAndEmployees[0];
                        _.assign(systemAndEmployee, updatedSystemAndEmployee);
                        
                    });
            }))
            .then(function () {
                $scope.view.isAuthorizing = false;
                var message = '<span class="gritter-title">' + $translate.instant('iam.itPurchasing.messages.allAuthorized') + '</span>';
                growl.addSuccessMessage(message, { enableHtml: true, ttl: 1 });
                $scope.toggleMultiSelection();
            });
    };

    $scope.overwriteInstructions = function () {
        $scope.view.acceptOverwrite = true;
    };

    $scope.showInstructions = function () {
        if (!$scope.getSelectedSystemsAndEmployees().length) { return false; }

        if ($scope.hasSomeWithInstructions() && !$scope.view.acceptOverwrite) { return false; }

        return true;
    }

    $scope.hasSomeWithInstructions = function () {
        return _.some($scope.getSelectedSystemsAndEmployees(), function (systemAndEmployee) {
            return !!systemAndEmployee.ITPurchasingInstructions;
        });
    };

    $scope.saveSelected = function () {
        $scope.view.isSaving = true;

        $q
            .all(_.map($scope.getSelectedSystemsAndEmployees(), function (systemAndEmployee) {
                _.assign(systemAndEmployee, $scope.multiSelectContainer);
                return ITPurchasingService.saveSignificantCost(systemAndEmployee);
            }))
            .then(function () {
                var message = '<span class="gritter-title">' + $translate.instant('iam.itPurchasing.messages.allInstructionsSaved') + '</span>';
                growl.addSuccessMessage(message, { enableHtml: true, ttl: 1 });
                $scope.view.isSaving = false;
            });
    };

    $scope.getSelectedSystemsAndEmployees = function () {
        return _.filter($scope.systemsAndEmployees, { isSelectedForMultiSelect: true });
    };
}]);